import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';

import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import { store, persistor, history } from './config/config-reducers';
import { PersistGate } from 'redux-persist/integration/react';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#2196F3',
      main: '#1976D2',
      dark: '#1565C0',
      contrastText: '#fff',
    },
    secondary: {
      light: '#42A5F5',
      main: '#1976D2',
      dark: '#0D47A1',
      contrastText: '#fff',
    },
    success: {
      light: '#81C784',
      main: '#4CAF50',
      dark: '#1B5E20',
      contrastText: '#fff'
    },
    problemsTable: {
      muted: '#aaa',
      problem: '#E53935'
    }
  },
});

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App history={history} />
      </PersistGate>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js